import { StatusEnum } from '@common/constants';

export function isLoading(status: StatusEnum): boolean {
  return status === StatusEnum.Uninitialized || status === StatusEnum.Pending;
}
